import Head from 'next/head';
import { ContentBrowser } from '@/components/content/ContentBrowser';
import { useUrlSync } from '@/lib/hooks/useUrlSync';

export default function ContentListPage() {
  const { values, handlers, isReady } = useUrlSync({
    filters: {
      search: { paramName: 'search', defaultValue: '' },
    },
  });

  return (
    <>
      <Head>
        <title>Content | Sizzle</title>
        <meta name="description" content="Browse hubs on Sizzle." />
      </Head>
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">Hubs</h1>
          {isReady && (
            <ContentBrowser
              query={{
                status: 'published',
                visibility: 'public',
                type: 'hub',
              }}
              initialSearch={values.search}
              onSearchChange={handlers.search}
              searchPlaceholder="Search hubs..."
              showFilters={false}
              showTypeFilter={false}
              filterLayout="mobile"
              limit={20}
            />
          )}
        </div>
      </div>
    </>
  );
}
